import React, { useState } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './styles.scss';

const TableHeader = ({ columns, onSortHandler, sortedItem }) => {
  let [sortDirection, setSortDirection] = useState(sortedItem.sortByAsc);

  return (
    <div className="table-header">
      {columns &&
        columns.length &&
        columns.map((item, index) => {
        const sortAsc =  sortedItem.sortField === item.fieldName ? 'asc' : '';
        const sortDesc = sortedItem.sortField === item.fieldName ? 'desc'  : '';
          return (
            <div key={`header-${item.fieldName}`} className = {`row-${item.widthInPercent}`}>
              <div key={item.fieldName} className={`${index === 0 ? 'table-header__firstCell' : 'table-header__col-cell'}`}	>
                <span className={`table-header__cell-label table-header__cell-label-wrap`} data-sort-order={'asc'}>
                  <div
                    className={item.isSortRequired ? 'table-header__sort' : ''}
                    onClick={() => {
                      if (item.isSortRequired) {
                        setSortDirection(!sortDirection);
                      }
                      onSortHandler({ sortField: item.fieldName, sortByAsc: !sortDirection });
                    }}
                  >
                    <span className={`table-header__cell-label-wrap`}>
                      {item.title}
                    </span>
                    {item.isSortRequired && (
                      <FontAwesomeIcon className={`table-header-fa-sort-${
                        sortedItem.sortByAsc
                        ? sortAsc
                      : sortDesc
                        }`} icon={sortDirection ? "arrow-up" : "arrow-down"} color={'#FAFBFD'} />
                    )}
                  </div>

                </span>
              </div>
            </div>
          )
        })
      }
    </div>
  )
}

export default TableHeader;